import React from 'react';
import { dialogs, layouts } from 'seal-ui-components';

/**This component is a partial abstraction of the seal-ui-components ModalDialog.
 * It will not work on its own. It needs an external trigger like a button for example.
 * In the click handler function of the external trigger, you will need to set the isVisible prop to "true",
 * and set the dialogAnimationStartDimension to an object that looks like this:
 *  { top: 0, left: 0, width: 0, height: 0 } for example
 * setting the value of dialogAnimationStartDimension can be done by calling the
 * calculateDialogStartPositionFromElement(element) function, where element is the external trigger.
 * This function is imported from '@Utils/domUtils'.
 * The returned value of the function will then be used to set dialogAnimationStartDimension.
 * Closing the dialog can be done by setting the isVisible prop to "false".
 * Looking at the implemetation will make everything much clearer.
 */

const NewDialogPopUp = ({ children, isVisible, dialogAnimationStartDimension }) => {
    const calculateAnimationStartDimension = () => {
        if (!dialogAnimationStartDimension) {
            return {
                top: 0,
                left: 0,
                width: 0,
                height: 0
            };
        }
        return dialogAnimationStartDimension;
    };

    return (
        <dialogs.ModalDialog
            size="small"
            hideCloseButton={true}
            isVisible={isVisible}
            onCalculateAnimationStartDimension={calculateAnimationStartDimension}
            className="suic-modal-dialog"
        >
            <layouts.VerticalBox style={{ width: '100vw' }}>{children}</layouts.VerticalBox>
        </dialogs.ModalDialog>
    );
};

export default NewDialogPopUp;
